export default {
  path: '/deepv-dashboard',
  name: 'deepv',
  redirect: '/v3/deepv',
};
